<ng-container *ngIf="loading() || (feesAndSupplements$ | async)?.length > 0">
  <lx-card-container styleClass="supplements__card-container" data-qa="supplements" [loading]="loading()">
    <div class="supplements">
      <ng-container *ngIf="feesAndSupplements$ | async as feesAndSupplements">
        <div
          *ngFor="let product of feesAndSupplements"
          class="supplements__item"
          [ngClass]="{ 'supplements__item--with-discount': !(product.price | lxEqual : product.endPrice : [{ property: 'value' }]) }"
        >
          <div class="supplements__item__name">{{ product.name }}</div>
          <lx-price-label [price]="product.price" [endPrice]="product.endPrice" [currency]="currency?.()"></lx-price-label>
        </div>
      </ng-container>
    </div>
  </lx-card-container>
</ng-container>
